import { Box, Link, Stack, Typography } from '@mui/material';
import { Checkbox } from '@my2n/react-hook-form-inputs';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RLink } from 'react-router-dom';
import { PATHS } from '../../config/consts';
import commonActions, { selectors as commonSelectors } from '../../modules/common';
import { useAppContext } from '../App/AppContextProvider';
import messages from './messages';

const styles = {
  checkbox: {
    '& .MuiCheckbox-root': {
      pt: 0,
    },
    label: {
      alignItems: 'flex-start',
    },
  },
  newslettersLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
};

export function RegisterGtc() {
  const { currentUserLang } = useAppContext();
  const dispatch = useDispatch();
  const helperText = useSelector(commonSelectors.getGtcOptOutHelperText);
  const label = useSelector(commonSelectors.getGtcOptOutLabel);

  useEffect(() => {
    dispatch(commonActions.getGtcOptOutText());
  }, [currentUserLang]);

  return (
    <Stack spacing={1}>
      <Box sx={styles.checkbox}>
        <Checkbox
          id="agreement-checkbox"
          label={
            <Typography component="span">
              <FormattedMessage
                values={{
                  linkcloud: (chunks) => (
                    <Link component={RLink} target="_blank" to={PATHS.CLOUD_AGREEMENT}>
                      {chunks}
                    </Link>
                  ),
                  linkinfo: (chunks) => (
                    <Link component={RLink} target="_blank" to={PATHS.INFORMATION_FOR_CONSUMERS}>
                      {chunks}
                    </Link>
                  ),
                  linkprivacy: (chunks) => (
                    <Link component={RLink} target="_blank" to={PATHS.PRIVACY_NOTICE_V2}>
                      {chunks}
                    </Link>
                  ),
                }}
                {...messages.RegisterAgreeLabelNew}
              />
            </Typography>
          }
          name="agree"
          required
        />
      </Box>
      {label && (
        <Box sx={styles.checkbox}>
          <Checkbox
            id="newsletter-checkbox"
            label={
              <Box sx={styles.newslettersLabel}>
                <Typography>{label}</Typography>
                {helperText && (
                  <Typography variant="caption" color="secondary">
                    {helperText}
                  </Typography>
                )}
              </Box>
            }
            name="newsletters"
          />
        </Box>
      )}
    </Stack>
  );
}
